import { Module } from 'vuex';
import { CateringBotState, RootState } from '../types';
import { getters } from './getters';
import { mutations } from './mutations';
import { actions } from './actions';

const namespaced: boolean = true;

export const state: CateringBotState = {
	enabled: false,
	lastInput: null,
	lastResults: null,
	refiningIndex: null
};

export const cateringBot: Module<CateringBotState, RootState> = {
	namespaced,
	state,
	getters,
	mutations,
	actions
};

export default cateringBot;
